import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "./locales/fr.json";
import en from "./locales/en.json";

const resources = {
  fr: { translation: fr },
  en: { translation: en }
};

const defaultLang = process.env.REACT_APP_LANG || "fr";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("lang") || defaultLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;